const getRawData = async () => {
    const res = await fetch('https://sheetdb.io/api/v1/dn485fyaqorjo');
    const sheetJson = await res.json();
    return sheetJson;
};
const parseRowData = (rawData) => ({
    date_received: new Date(rawData['Date received']),
    date_delivered: new Date(rawData['Date delivered']),
    title: rawData.Title,
    character_count: parseInt(rawData['Character count'].replace(",", '')),
    usd: parseFloat(rawData.USD.substring(1).replace(",", '')),
    nis: parseFloat(rawData.NIS.substring(2).replace(",", '')),
    euro: parseFloat(rawData['[EUR]'].substring(1).replace(",", ''))
});
export const getData = async () => {
    const rawData = await getRawData();
    return rawData.map(parseRowData);
};
